import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  ScheduledEmailUpcomingColumnServiceFactory,

  ScheduledEmailService,
  ScheduledEmailRepository,

  ScheduledEmailFetchService,
  ScheduledEmailFetchRepository,

  ScheduledEmailFailedFetchService,
  ScheduledEmailFailedFetchRepository,

  ScheduledEmailRecipientsService,
  ScheduledEmailRecipientsRepository,

  ScheduledEmailSingleRecipientService,
  ScheduledEmailSingleRecipientRepository,

  ScheduledEmailUpcomingBulkManager,
  ScheduledEmailUpcomingGridable,

  ScheduledEmailPausedColumnServiceFactory,
  ScheduledEmailPausedBulkManager,
  ScheduledEmailPausedGridable,

  ScheduledEmailCompletedColumnServiceFactory,
  ScheduledEmailCompletedBulkManager,
  ScheduledEmailCompletedGridable,

  ScheduledEmailNotSentColumnServiceFactory,
  ScheduledEmailNotSentBulkManager,

  ScheduledEmailSingleService,
  ScheduledEmailSingleRepository,
  ScheduledEmailDetailsResolverService,
  ScheduledEmailCampaignFailedAttemptStateUpdatedWebsocketResolverService,
}

export type ScheduledEmailServices = keyof typeof SERVICES

export const SCHEDULED_EMAIL_SERVICE_TYPES: Record<ScheduledEmailServices, symbol> =
  makeServicesTypes<ScheduledEmailServices>(enumKeysToArray<ScheduledEmailServices>(SERVICES))
